import React, { useState } from "react";
import 'react-multi-carousel/lib/styles.css';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';

import NoraHomepage from '../../images/homepage/nora-homepage.png';

import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import Review5 from "../../images/homepage/review5.png";
import Review6 from "../../images/homepage/review6.png";
import Review7 from "../../images/homepage/review7.png";
import Review8 from "../../images/homepage/review8.png";
import Review9 from "../../images/homepage/review9.png";
import Container from "../../images/homepage/container.png";
import ContainerMobile from "../../images/homepage/containerMobile.png";

import CompanyCards from '../../components/CompanyCards';
import SEO from '../../components/SEO';
import { generateBreadcrumbSchema, generateFAQSchema } from '../../utils/schemaGenerator';

function ComparisonExponent() {
  let navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: 'Home', url: 'https://interview.norahq.com' },
    { name: 'Exponent Alternative', url: 'https://interview.norahq.com/exponent-alternative' }
  ]);

  const exponentFaqEntries = [
    {
      question: 'How is Nora different from Exponent?',
      answer: 'Nora offers instant, voice-based mock interviews with personalized feedback and improvement plans. Exponent focuses on peer-matched sessions, courses, and community that typically require scheduling.'
    },
    {
      question: 'Do I need to schedule with Nora?',
      answer: 'No. You can start a realistic mock interview immediately—no peer matching or calendars required.'
    },
    {
      question: 'How much does Nora cost?',
      answer: 'Your first mock interview is free. Then it’s $15/month with an annual option.'
    }
  ];

  const faqSchema = generateFAQSchema(exponentFaqEntries);

  return (
    <> 
    <SEO
      title="Exponent Alternative — Instant Mock Interviews with Nora (No Scheduling, $15/mo)"
      description="Compare Nora vs Exponent: instant, voice-based mock interviews with personalized feedback and action plans. Practice anytime for $15/month—no peer scheduling needed."
      url="https://interview.norahq.com/exponent-alternative"
      openGraph={{
        title: 'Exponent Alternative — Instant Mock Interviews with Nora',
        description: 'Practice today, not next week. Instant mocks, detailed feedback, and $15/mo pricing.'
      }}
      schemas={[breadcrumbSchema, faqSchema]}
    />
      <div className="comparison-container">
        {/* Hero Section */}
        <div className="screening-hero-section">
          <div className="screening-hero-content">
            <div className="screening-hero-left">
              <h1 className="position-title-h1">
                Exponent Alternative — Practice Mock Interviews with Nora
              </h1>
              <p className="position-title-p">
                Exponent matches you with peers and offers courses and community. 
                Nora gives you <strong>instant, realistic mock interviews</strong>—no scheduling—plus 
                detailed feedback and a step-by-step improvement plan.
                <br /><br />
                Build real confidence and improve faster at <strong>$15/month</strong> vs Exponent’s <strong>$79/month</strong> membership.
              </p>

              <div className="btn-container2">
                <button
                  className="nora-button-style"
                  onClick={() => window.open('https://interview.norahq.com', '_blank')}
                  style={isMobile ? { fontSize: '16px' } : {}}
                >
                  Try Nora AI Free
                </button>

                <button
                  onClick={() => window.location.href = '#comparison'}
                  className="nora-button2-style"
                >
                  See Comparison
                </button>
              </div>

              <div className="trust-indicators">
                <div className="trust-item">
                  <span className="checkmark">✓</span>
                  <span>Realistic voice interviews</span>
                </div>
                <div className="trust-item">
                  <span className="checkmark">✓</span>
                  <span>Actionable feedback & plans</span>
                </div>
                <div className="trust-item">
                  <span className="checkmark">✓</span>
                  <span>Instant practice—no scheduling</span>
                </div>
              </div>
            </div>

            <div className="screening-hero-right">
              <div>
                <img
                  src={NoraHomepage}
                  alt="Nora AI - Ethical Interview Preparation"
                  style={{ maxWidth: '100%', display: 'block' }} />
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Comparison Section */}
        <div className="pricing-comparison-section" id="pricing-exponent">
          <h2 className="pricing-title2">Practice today for $15. Skip the $79 calendar shuffle</h2>

          <div className="pricing-cards-container">
            {/* Nora AI Card */}
            <div className="pricing-card2 pricing-card-featured">
              <div className="pricing-card-header">
                <div>
                  <h3 className="pricing-card-title">Nora AI</h3>
                  <p className="pricing-card-subtitle">Instant mock interview prep</p>
                </div>
                <div className="pricing-badge">
                  <span>⚡</span>
                </div>
              </div>

              <div className="pricing-amount-container">
                <span className="pricing-currency">$</span>
                <span className="pricing-amount2">15</span>
                <span className="pricing-period2">/month</span>
              </div>

              <button
                className="pricing-cta-button pricing-cta-primary"
                onClick={() => window.open('https://interview.norahq.com', '_blank')}
              >
                Start for free <span className="arrow-icon">→</span>
              </button>

              <div className="pricing-features-list">
                <div className="pricing-feature-item"><span className="feature-check">✓</span><span>Unlimited mock interviews</span></div>
                <div className="pricing-feature-item"><span className="feature-check">✓</span><span>Instant mock interviews — no scheduling needed</span></div>
                <div className="pricing-feature-item"><span className="feature-check">✓</span><span>Technical, behavioral & negotiation modes</span></div>
                <div className="pricing-feature-item"><span className="feature-check">✓</span><span>Resume & JD matching</span></div>
                <div className="pricing-feature-item"><span className="feature-check">✓</span><span>3-week & 1-month action plans</span></div>
                <div className="pricing-feature-item"><span className="feature-check">✓</span><span>Massive real-company question bank</span></div>
              </div>
            </div>

            {/* Exponent Card */}
            <div className="pricing-card2 pricing-card-competitor">
              <div className="pricing-card-header">
                <div>
                  <h3 className="pricing-card-title">Exponent</h3>
                  <p className="pricing-card-subtitle">Peer mocks + courses</p>
                </div>
                <div className="pricing-badge pricing-badge-warning">
                  <span>💰</span>
                </div>
              </div>

              <div className="pricing-amount-container">
                <span className="pricing-currency">$</span>
                <span className="pricing-amount2">79</span>
                <span className="pricing-period2">/month</span>
              </div>

              <button className="pricing-cta-button pricing-cta-disabled">
                💸 Practice next month and pay more <span className="arrow-icon">→</span>
              </button>

              <div className="pricing-features-list">
                <div className="pricing-feature-item"><span className="feature-check">✓</span><span>Peer-to-peer mock interviews</span></div>
                <div className="pricing-feature-item"><span className="feature-check">✓</span><span>Courses & question bank</span></div>
                <div className="pricing-feature-item"><span className="feature-check">✓</span><span>Community & referrals</span></div>
                <div className="pricing-feature-item"><span className="feature-check">✓</span><span>AI feedback (members only)</span></div>
                <div className="pricing-feature-item pricing-feature-negative"><span className="feature-cross">✕</span><span>Requires scheduling with peers</span></div>
                <div className="pricing-feature-item pricing-feature-negative"><span className="feature-cross">✕</span><span>Variable partner quality</span></div>
                <div className="pricing-feature-item pricing-feature-negative"><span className="feature-cross">✕</span><span>Higher ongoing cost</span></div>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits/Differences Section */}
        <div className="benefits-section" id="comparison">
          <div className="benefits-content">
            <div className="benefits-left">
              <h2 className="benefits-title">How is Nora different from Exponent?</h2>
              <p className="benefits-description">
                Nora is built for fast, solo practice with actionable feedback—no calendar juggling.
              </p>

              <div className="benefits-tags">
                <span className="benefit-tag">Instant practice</span>
                <span className="benefit-tag">Detailed feedback</span>
                <span className="benefit-tag">Skill growth</span>
                <span className="benefit-tag">Lower cost</span>
              </div>
            </div>

            <div className="benefits-right">
              <div className="benefit-point">
                <div className="benefit-icon">⚡</div>
                <div className="benefit-content">
                  <h3 className="benefit-heading">No scheduling required</h3>
                  <p className="benefit-text">
                    Jump into a realistic mock right away. Practice fits your day—no waiting for a peer match.
                  </p>
                  <a href="#pricing-exponent" className="benefit-link" onClick={() => window.location.href = '#pricing-exponent'}>See pricing comparison →</a>
                </div>
              </div>

              <div className="benefit-point">
                <div className="benefit-icon">🧭</div>
                <div className="benefit-content">
                  <h3 className="benefit-heading">Guided improvement plans</h3>
                  <p className="benefit-text">
                    After every session, get specific fixes and a plan for the next 3–4 weeks to move your scores up.
                  </p>
                  <a href="https://interview.norahq.com" className="benefit-link">Try Nora free →</a>
                </div>
              </div>

              <div className="benefit-point">
                <div className="benefit-icon">💸</div>
                <div className="benefit-content">
                  <h3 className="benefit-heading">Lower monthly cost</h3>
                  <p className="benefit-text">
                    Keep consistent practice going for $15/month instead of $79/month memberships.
                  </p>
                  <a href="#comparison" className="benefit-link" onClick={() => window.location.href = '#comparison'}>See full comparison →</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* How it works */}
        <div className="outsourcing-solution" id="how-it-works">
          <h2 className="outsourcing-heading">How Nora Works</h2>
          <p className="outsourcing-description">
            3 simple steps to level up your interview game
          </p>
        </div>

        <div className="how-it-works-1-partnership">
          <img src={isMobile ? ContainerMobile : Container} loading="lazy" alt="Feedback" id="feedback-picture" className='image2-styling' />
        </div>

        <div className="outsourcing-solution">
          <h2 className="outsourcing-heading">Watch Nora in Real Time</h2>
          <p className="outsourcing-description" style={{ marginBottom: '50px' }}>
            Watch how Nora works in real life, and can offer valuable interview practice.
          </p>
          <iframe
            width={isMobile ? "380" : "640"}
            height={isMobile ? "214" : "360"}
            src="https://www.youtube.com/embed/7u0Rf3D_jN0?si=wlmJwsxo5_QjGrrl"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen>
          </iframe>
        </div>

        {/* Social proof */}
        <div className="cool-homepage-section">
          <h2 className="outsourcing-heading">"This feels like having the interview questions a day before."</h2>
          <div className="button-container">
            <button className="nora-button-style"
              style={{ marginTop: '10px' }}
              onClick={() => navigate("/login")}>
              And the interview answers.
            </button>
          </div>
        </div>

        <div className="cta-container" id="testimonials">
          <div className="cta-text">Hear from Applicants like you</div>
        </div>
        <div>
          <Swiper
            spaceBetween={0}
            slidesPerView={isMobile ? 1 : 3}
            modules={[Pagination]}
            pagination={{ clickable: true }}
            style={{ margin: 'auto', paddingBottom: '70px', paddingTop: '20px' }}
          >
            <SwiperSlide>
              <div className="card">
                <div className="card-top">
                  <img src={Review5} alt="Samantha Chou Photo" className="card-image-styling" />
                </div>
                <div className="card-content">
                  <h3>Samantha Chou</h3>
                  <p className="title">PM Intern at Amazon</p>
                  <p className="quote">“Nora is a helpful and easy-to-use mock interview tool. Love the interactive nature and the question-by-question feedback and analysis!”</p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="card">
                <div className="card-top">
                  <img src={Review7} alt="Dev Popat Photo" className="card-image-styling" />
                </div>
                <div className="card-content">
                  <h3>Dev Popat</h3>
                  <p className="title">SWE at Roku</p>
                  <p className="quote">“I completed 3 mock interviews before my actual interview at Roku, and 4 out of the 7 questions were exactly the same!”</p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="card">
                <div className="card-top">
                  <img src={Review8} alt="Julia Son Photo" className="card-image-styling" />
                </div>
                <div className="card-content">
                  <h3>Julia Son</h3>
                  <p className="title">Marketing at Meta</p>
                  <p className="quote">“Easily the best way to prepare for an interview… personalized feedback, great resource!”</p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="card">
                <div className="card-top">
                  <img src={Review6} alt="Carissa Wu Photo" className="card-image-styling" />
                </div>
                <div className="card-content">
                  <h3>Carissa Wu</h3>
                  <p className="title">Computer Engineering, Senior</p>
                  <p className="quote">“Great tool that simulates real life interviews… the questions matched my actual interview.”</p>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="card">
                <div className="card-top">
                  <img src={Review9} alt="Sydney Nguyen Photo" className="card-image-styling" />
                </div>
                <div className="card-content">
                  <h3>Sydney Nguyen</h3>
                  <p className="title">Sales, Senior at UCR</p>
                  <p className="quote">“Realistic questions and resume-aware prompts. 100% recommend!”</p>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        {/* Company Mock Interview Section */}
        <div>
          <h2 className="company-mock-section-section">Jump start your interview practice now.</h2>
          <CompanyCards />
        </div>

        <div className={isMobile ? "practiceNoraCard-mobile" : "practiceNoraCard"}>
          <div style={{ textAlign: "center" }}>
            <div className={isMobile ? "practiceNoraCardHead-mobile" : "practiceNoraCardHead"}>Ready to begin mastering interviews with Nora?</div>

            <button className="nora-button-style" onClick={() => navigate("/login")}>
              Practice Now
            </button>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default ComparisonExponent;
